/* modules */
import { Component, OnInit, ViewContainerRef, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';

/* services */
import { CardHttpService } from './../../core/http/internal/card.http.service';
import { CountryHttpService } from './../../core/http/internal/country.http.service';
import { AddressAutocompleteModel } from '../../shared/components/autocomplete/address-autocomplete.model';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../shared/shared.service';
import { ClientService } from '../../core/http/internal/client.http.service';
import { TrialHttpService } from './../../core/http/internal/trial.http.service';
import { DxTextBoxComponent } from 'devextreme-angular/ui/text-box';
import { DxValidationGroupComponent } from 'devextreme-angular/ui/validation-group';
import { AccountPageHttpService } from '../../core/http/internal/accountpage.http.service';
import { EcommerceComponent } from '../../shared/ecommerce/ecommerce';
import { Product } from '../../shared/ecommerce/models/ecommerceProduct';
import { CategoryTypes } from '../../shared/ecommerce/enums/categoryTypes';
import { TransactionTypes } from '../../shared/ecommerce/enums/transactionTypes';

@Component({
    selector: 'card-app',
    template: require('./card.component.html'),
    providers: [TrialHttpService, CardHttpService, CountryHttpService, ClientService, AccountPageHttpService],
})

export class CardComponent implements OnInit {

    isNeedToEnterShippingAddress = false;
    items: any[];
    autocompleteElabled = true;
    viewModel = new CardFormData();
    showResultForm = false;
    states: any = [];
    loadIndicatorVisible = false;
    public address: any;

    public hasAccount = false;
    public clickedOption = true;
    public userSuspendStatus = 1;

    public hasAuthorized = false;
    public preload = true;

    showTrialAllowedAlert = false;
    isTrialAllowed = true;
    isTrialAllowedText: string;
    info: string[];

    features = [
        new Feature(null, 'i-b-channels.png', 'Более 140 каналов из России и стран СНГ'),
        new Feature('/features/archive', 'i-b-archive_1.png', 'Повтор пропущенных программ в Архиве'),
        new Feature('/tv/how-to-watch', 'i-b-multy.png', 'Смотрите на разных устройствах'),
        new Feature('/features/videos', 'i-b-videoteka_1.png', 'Более 80,000 фильмов и&nbsp;сериалов')
    ];

    textboxPattern: any = '^(?!.*[\u0430-\u044F\u0410-\u042F\u0451\u0401]).*$';
    emailPattern: any = '/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))' +
        '@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/';
    namePattern: any = /^([a-zA-Z \-\'])*$/;
    trialDisabledPattern: any = /^((?!CC)(?!7D)).*$/i;

    public addressTypeEnum = { 'billing': 1, 'shipping': 2 };
    public locale = 'ru';

    @ViewChild('cardCodeTextBox', { static: false }) public cardCodeTextBox: DxTextBoxComponent;
    @ViewChild('shippingGroup', { static: false }) public shippingGroup: DxValidationGroupComponent;

    constructor(
        public vcRef: ViewContainerRef,
        private readonly cardService: CardHttpService,
        private readonly toastr: ToastrService,
        private readonly sharedService: SharedService,
        private readonly clientService: ClientService,
        private readonly trialService: TrialHttpService,
        public accountPageHttpService: AccountPageHttpService,
    ) {
    }

    async ngOnInit(): Promise<void> {
        this.hasAuthorized = this.sharedService.hasAuthorized;
        this.viewModel.email = this.sharedService.email;
        this.viewModel.cardcode = this.sharedService.code;
        this.checkTrialCardsAvailable();
        this.checkGift();
        await this.activate();
    }

    public checkTrialCardsAvailable() {
        this.trialService.checkTrialCardsAvailable().subscribe(result => {
            if (result.errors && result.errors.length > 0) {
                this.isTrialAllowed = false;
                this.isTrialAllowedText = result.errors[0];
            } else {
                this.isTrialAllowed = true;
            }
        });
    }

    public checkGift() {
        if (this.sharedService.giftId) {
            this.clientService.getClientGift(this.sharedService.giftId).subscribe(response => {
                if (response.errors && response.errors.length > 0) {
                    //ignore error
                } else {
                    this.viewModel.cardcode = response.result.activationCode;
                    if (!this.hasAuthorized) {
                        this.viewModel.firstname = response.result.firstName;
                        this.viewModel.lastname = response.result.lastName;
                        this.viewModel.email = response.result.email;
                    }
                }
            });
        }
    }

    private async activate(): Promise<void> {
        if (this.hasAuthorized) {

            const result = await this.clientService.getClientStatus();

            if (result >= this.userSuspendStatus) {
                window.location.href = 'card/unavailable';
                return;
            }

            this.preload = false;
        } else {
            this.preload = false;
        }
    }

    onHasAccount(value: boolean) {
        this.viewModel.errors = [];
        this.hasAccount = value;
        this.clickedOption = true;
    }

    checkTrialActivation(event: any) {
        const inputValue = this.cardCodeTextBox.text;
        const pattern = new RegExp(this.trialDisabledPattern);
        const result = pattern.test(inputValue);
        this.showTrialAllowedAlert = !result;
    }

    phoneChange(value: any) {
        this.viewModel.phone = value;
    }

    phoneCountryCodeChange(value: any) {
        this.viewModel.phoneCountryCode = value;
    }

    async submit(): Promise<void> {
        this.viewModel.errors = [];
        try {
            if (!this.hasAuthorized && !this.hasAccount && !this.viewModel.addressModel.city) {
                this.viewModel.errors = ['Город - обязательное поле'];
                return;
            }

            this.viewModel.city = this.viewModel.addressModel.city;
            this.viewModel.province = this.viewModel.addressModel.province;
            this.viewModel.countryCode = this.viewModel.addressModel.countryCode;
            this.loadIndicatorVisible = true;

            const giftCards = ['GM', 'GT', 'GY'];
            if (giftCards.some(x => x === this.viewModel.cardcode.substring(0, 2))) {
                this.cardService.checkActivationCardHasDevice({
                    cardCode: this.viewModel.cardcode
                }).subscribe(response => {
                    if (!response.result) {
                        this.activateCard();
                    } else {
                        this.viewModel.errors = [];
                        if (this.hasAuthorized) {
                            this.accountPageHttpService.getCurrentUserInfo().subscribe((x: any) => {
                                this.viewModel.shippingAddress = x.shippingAddress;
                                this.loadIndicatorVisible = false;
                                this.isNeedToEnterShippingAddress = true;
                                return;
                            });
                        } else {
                            this.viewModel.createShippingAddress();
                            this.loadIndicatorVisible = false;
                            this.isNeedToEnterShippingAddress = true;
                            return;
                        }
                    }
                });
            } else {
                this.activateCard();
            }

        } catch (err) {
            this.loadIndicatorVisible = false;
            this.toastr.error(`Ошибка при активации карты! ${err.toString()}`);
        }
    }

    submitWithAddress() {
        const validationResult = this.shippingGroup.instance.validate().isValid;
        if (validationResult) {
            this.loadIndicatorVisible = true;
            this.activateCard();
        } else {
            //form is not valid
            return;
        }
    }

    activateCard() {
        let serviceFunction: Observable<any>;
        if (this.hasAuthorized) {
            serviceFunction = this.cardService.activationCardForAuthorizedUser(this.viewModel);
        } else {
            if (this.hasAccount) {
                serviceFunction = this.cardService.activationCardForRegisteredUser(this.viewModel);
            } else {
                serviceFunction = this.cardService.activationCardForUnRegisteredUser(this.viewModel);
            }
        }

        serviceFunction.subscribe(result => {
            this.loadIndicatorVisible = false;
            if ('undefined' !== typeof result.errors && result.errors.length > 0) {
                this.viewModel.errors = result.errors;
            } else {
                this.showResultForm = true;

                if (this.hasAuthorized || this.hasAccount) {
                    const term = `${result.result.packagePrice.term.quantity}${result.result.packagePrice.term.period}`;
                    const object = {
                        'event': 'accesscard',
                        'cardActivationCode': result.result.cardActivationCode,
                        'subscriptionType': term
                    };
                    (window as any)['dataLayer'].push(object);

                    if (result.result.transactionId) {
                        this.processEcommerce(
                            result.result.activatedClient, result.result.transactionId, term, result.result.packagePrice);
                    }
                }
            }
        });
    }

    processEcommerce(client: any, transactionId: string, term: string, packagePrice: any) {
        let ecommerceComponent = new EcommerceComponent();
        ecommerceComponent = ecommerceComponent
            .setPromo('')
            .setDebug((client.firstName === 'John' && client.lastName === 'Rambo'))
            .setClient({
                firstName: client.firstName,
                lastName: client.lastName,
                provinceName: client.billingAddress.countryRegion.name,
                countryName: client.billingAddress.countryRegion.country.name,
                isLegacy: false,
                readableId: client.readableId,
                shippingCountry: null,
                id: client.readableId
            })
            .setTransaction(transactionId);

        const product = new Product()
            .setName(`${packagePrice.package.name} (${packagePrice.packagePriceTypeName})`)
            .setId(`prepaid_${packagePrice.id}`)
            .setPrice(0)
            .setTerm(term)
            .setCategory(CategoryTypes.AccessCard);

        const isTrial = packagePrice.term.weekly;

        ecommerceComponent.addProduct(product, 1);
        ecommerceComponent.send(isTrial, TransactionTypes.CardActivation);
    }

    clear(): void {
        this.viewModel.addressModel.province = null;
        this.viewModel.addressModel.countryCode = null;
        this.viewModel.addressModel.city = null;
    }

    getAddress2(address: any): string {
        const html: any[] = [];
        html.push(
            address.address1 != null ? address.address1 + ', ' : '',
            address.city != null ? address.city + ', ' : '',
            address.countryRegion != null && (address.countryRegion.code != null) ? address.countryRegion.code + ', ' : '',
            address.zip != null ? address.zip : ''
        );
        return html.join('');
    }

    getAddress(place: any) {
        const state = place.address_components.filter((obj: any) => (obj.types[0]) === 'administrative_area_level_1')[0];
        this.viewModel.addressModel.province = state.short_name;

        const countryCode = place.address_components.filter((obj: any) => (obj.types[0]) === 'country')[0];
        this.viewModel.addressModel.countryCode = countryCode.short_name;

        const locality = place.address_components.filter((obj: any) => (obj.types[0]) === 'locality')[0];
        if (locality != null) {
            this.viewModel.addressModel.city = locality.short_name;
        } else {
            const adminArea = place.address_components.filter((obj: any) => (obj.types[0]) === 'administrative_area_level_3')[0];
            this.viewModel.addressModel.city = adminArea.short_name;
        }
    }
}

class CardFormData {
    public firstname: string;
    public lastname: string;
    public email: string;
    public cardcode: string;
    public city: string;
    public province: string;
    public addressCountry = 124; //canada
    public addressModel: AddressAutocompleteModel;
    public errors: any[];
    public countryCode: string;
    public password: string;
    public phone: string;
    public phoneCountryCode: string;
    public shippingAddress: any;

    constructor() {
        this.addressModel = new AddressAutocompleteModel();
        this.addressModel.country = this.addressCountry;
        this.phoneCountryCode = '1';
    }

    createShippingAddress() {
        this.shippingAddress = {
            address: '',
            address2: '',
            countryRegion: {
                country: {
                    iso2: ''
                },
                code: ''
            },
            city: '',
            postalCode: '',
            firstName: '',
            lastName: ''
        };
    }
}

class Feature {
    public url: string;
    public imgUrl: string;
    public title: string;

    constructor(url: string, imgUrl: string, title: string) {
        this.url = url;
        this.imgUrl = imgUrl;
        this.title = title;
    }
}



// WEBPACK FOOTER //
// ./src/app/card/components/card.component.ts